import { render, staticRenderFns } from "./submitExam.vue?vue&type=template&id=d53dbf58&scoped=true&"
import script from "./submitExam.vue?vue&type=script&lang=js&"
export * from "./submitExam.vue?vue&type=script&lang=js&"
import style0 from "./submitExam.vue?vue&type=style&index=0&id=d53dbf58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53dbf58",
  null
  
)

export default component.exports